<div class="sp-width__full sp-grid__summary-3 sp-grid__gap sp-overflow__x-scroll">
  <app-shared-summary-item
    [item_label]="'STORES.SUMMARY_ALL_LABEL'"
    [item_value]="summary?.length?.toString() || '0'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'STORES.SUMMARY_ENABLED_LABEL'"
    [item_value]="summary?.enabled?.toString() || '0'"
    [item_class]="'sp-background__status-50'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'STORES.SUMMARY_DISABLED_LABEL'"
    [item_value]="summary?.disabled?.toString() || '0'"
    [item_class]="'sp-background__status-300'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
</div>
